export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1.0"},{"charset":"utf-8"},{"name":"description","content":"자녀의 학습능력을 올려보세요."},{"property":"og:title","content":"가디앤ㅣ우리가족 생활 코치"},{"property":"og:description","content":"자녀의 학습능력을 올려보세요."},{"property":"og:image","content":"/og_image.png"},{"property":"og:url","content":"https://www.guardianns.com/"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"preload","href":"/fonts/NanumSquareNeoOTF-Bd.woff2","as":"font","type":"font/woff2","crossorigin":""},{"rel":"preload","href":"/fonts/NanumSquareNeoOTF-Eb.woff2","as":"font","type":"font/woff2","crossorigin":""},{"rel":"preload","href":"/fonts/NanumSquareNeoOTF-Hv.woff2","as":"font","type":"font/woff2","crossorigin":""},{"rel":"preload","href":"/fonts/NanumSquareNeoOTF-Lt.woff2","as":"font","type":"font/woff2","crossorigin":""},{"rel":"preload","href":"/fonts/NanumSquareNeoOTF-Rg.woff2","as":"font","type":"font/woff2","crossorigin":""},{"rel":"preload","href":"/fonts/NotoSans-Bold.woff2","as":"font","type":"font/woff2","crossorigin":""},{"rel":"preload","href":"/fonts/NotoSans-ExtraBold.woff2","as":"font","type":"font/woff2","crossorigin":""},{"rel":"preload","href":"/fonts/NotoSans-Light.woff2","as":"font","type":"font/woff2","crossorigin":""},{"rel":"preload","href":"/fonts/NotoSans-Medium.woff2","as":"font","type":"font/woff2","crossorigin":""},{"rel":"preload","href":"/fonts/NotoSans-Regular.woff2","as":"font","type":"font/woff2","crossorigin":""}],"style":[],"script":[{"src":"https://www.googletagmanager.com/gtag/js?id=G-D5NSY347VZ","async":true}],"noscript":[],"charset":"utf-8","viewport":"width=device-width, initial-scale=1.0","title":"가디앤ㅣ우리가족 생활 코치"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true